// extracted by mini-css-extract-plugin
module.exports = {"tags":"JobCategoriesField_tags__SRXTZ","item":"JobCategoriesField_item__1v_hl","sending":"JobCategoriesField_sending__8nau_"};